import { useState } from "react";
import { Button, Divider, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { userState } from "../../interface/MainInterface";
import ReservationRobotCleaner from "./ReservationRobotCleaner";
import ReservationRobotCleanerEnd from "./ReservationRobotCleanerEnd";

interface propsType {
  userState: userState;
  userInfo: userState;
  handleClose: () => void;
}

const ReservationRobotCleanerAdmin = (props: propsType) => {
  const [reloadKey, setReloadKey] = useState(0);
  const reloadReservations = () => setReloadKey((prev) => prev + 1);

  return (
    <Stack
      spacing={2}
      sx={{
        width: "100%",
        maxWidth: "44rem",
        margin: "0 auto",
        px: 2,
        pb: 4,
        boxSizing: "border-box",
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ pt: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          {props.userInfo.userName}님 창문 로봇청소기 예약 관리
        </Typography>
        <Button color="inherit" onClick={props.handleClose} startIcon={<CloseIcon />}>
          닫기
        </Button>
      </Stack>

      <ReservationRobotCleaner
        userState={props.userState}
        reservationUser={props.userInfo}
        adminMode
        hideNavigation
        reloadKey={reloadKey}
        onReservationSuccess={reloadReservations}
      />

      <Divider />

      <ReservationRobotCleanerEnd
        userState={props.userState}
        reservationUser={props.userInfo}
        adminMode
        hideReservationButton
        reloadKey={reloadKey}
        onReservationChange={reloadReservations}
      />
    </Stack>
  );
};

export default ReservationRobotCleanerAdmin;
